import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Shift } from 'app/models/shift.models';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ShiftsService {
 
  constructor(private http: HttpClient) { }
  
  getTurnos(): Observable<Shift | any> {
    return this.http.get(environment.apiUrl + 'shift');
  }

  getTurno(id: number) {
    return this.http.get(environment.apiUrl + 'shift/' + id);
  }

  updateTurno(id: number, value: any) {
    return this.http.patch(environment.apiUrl + 'shift/' + id, value);
  }

  saveTurno(value: any) {
    return this.http.post(environment.apiUrl + 'shift', value);
  }

  deleteTurno(id: number) {
    return this.http.delete(environment.apiUrl + 'shift/' + id);
  }
}
